export default function AudioSection() {
  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          
          {/* Left: Content */}
          <div className="space-y-6">
            <div className="inline-block bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold">
              <i className="ri-headphone-line mr-2"></i>
              Featured Audio
            </div>
            
            <h2 className="text-4xl font-bold text-gray-900 border-l-4 border-teal-500 pl-4">
              Hear the Consistency Paradox Explained
            </h2>
            
            <p className="text-lg text-gray-700 leading-relaxed">
              In this compelling audio introduction, Alberto Rocha reveals the groundbreaking thesis of "AI Is More Human Than Humans" — exploring how artificial intelligence exposes the structural failures in human moral judgment and decision-making.
            </p>

            <div className="space-y-4 pt-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">The Core Paradox</h4>
                  <p className="text-gray-600">Discover why AI's consistency reveals human moral inconsistency</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Research-Backed Insights</h4>
                  <p className="text-gray-600">Evidence from behavioral economics and AI ethics</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900">Practical Applications</h4>
                  <p className="text-gray-600">How this understanding transforms decision-making</p>
                </div>
              </div>
            </div>

            <div className="pt-6">
              <a 
                href="#contact" 
                className="inline-block bg-teal-500 hover:bg-teal-600 text-white font-semibold py-3 px-8 rounded-full transition-colors whitespace-nowrap cursor-pointer"
              >
                Get the Book
              </a>
            </div>
          </div>

          {/* Right: Audio Player */}
          <div className="space-y-6">
            <div className="bg-gradient-to-br from-teal-50 to-gray-50 p-8 rounded-2xl shadow-xl border border-teal-100">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-volume-up-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900">Book Introduction</h3>
                  <p className="text-gray-600">AI Is More Human Than Humans</p>
                </div>
              </div>

              {/* SoundCloud Embed */}
              <div className="bg-white rounded-xl overflow-hidden shadow-md">
                <iframe 
                  width="100%" 
                  height="300" 
                  scrolling="no" 
                  frameBorder="no" 
                  allow="autoplay"
                  src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/soundcloud%253Atracks%253A2214565352&color=%2314b8a6&auto_play=false&hide_related=true&show_comments=false&show_user=true&show_reposts=false&show_teaser=false&visual=true"
                  title="AI Consistency Exposes Human Moral Failures"
                ></iframe>
              </div>

              <div className="mt-6 flex items-center justify-between text-sm text-gray-600">
                <div className="flex items-center space-x-2">
                  <i className="ri-time-line text-teal-600"></i>
                  <span>Listen to understand the paradox</span>
                </div>
              </div>
            </div>

            {/* Additional Context */}
            <div className="bg-gray-900 text-white p-6 rounded-xl">
              <div className="flex items-start space-x-3">
                <i className="ri-lightbulb-line text-teal-400 text-xl mt-1"></i>
                <div>
                  <h4 className="font-semibold mb-2">Why This Matters</h4>
                  <p className="text-gray-300 text-sm leading-relaxed">
                    This audio establishes the credibility and foundation of Alberto's groundbreaking work, demonstrating how AI serves as a mirror to human decision-making flaws and offers a path toward more consistent ethical frameworks.
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}